<div class="recovery-code-step">
  <p class="authentication__right__card_title">
    {{ 'LOGIN.AUTH.RECOVERY_CODE.TITLE' | translate }}
  </p>

  <div class="authentication__right__card__field" fxLayout="column" fxLayoutAlign="center stretch">
    <p class="authentication__right__card_description">
      {{ 'LOGIN.AUTH.RECOVERY_CODE.DESCRIPTION' | translate }}
    </p>

    <input
      #recoveryCodeInputElement
      type="text"
      name="recovery-code"
      class="recovery-code-step__input mt-27"
      [formControl]="recoveryCodeInput"
      [placeholder]="'LOGIN.AUTH.RECOVERY_CODE.PLACEHOLDER' | translate"
      novalidate
    />

    <div *ngIf="recoveryCodeInput.touched" class="mt-8">
      <small class="authentication__right__card__field-error" *ngIf="recoveryCodeInput.hasError('required')">
        {{ 'LOGIN.AUTH.RECOVERY_CODE.ERRORS.REQUIRED' | translate }}
      </small>

      <small class="authentication__right__card__field-error" *ngIf="recoveryCodeInput.hasError('incorrect')">
        {{ 'LOGIN.AUTH.RECOVERY_CODE.ERRORS.INCORRECT' | translate }}
      </small>

      <small class="authentication__right__card__field-error" *ngIf="recoveryCodeInput.hasError('used')">
        {{ 'LOGIN.AUTH.RECOVERY_CODE.ERRORS.USED' | translate }}
      </small>

      <small class="authentication__right__card__field-error" *ngIf="recoveryCodeInput.hasError('revoked')">
        {{ 'LOGIN.AUTH.RECOVERY_CODE.ERRORS.REVOKED' | translate }}
      </small>
    </div>

    <p class="authentication__right__card_description mt-22">
      {{ 'LOGIN.AUTH.RECOVERY_CODE.WARNINGS' | translate }}
      <b class="cursor-pointer" (click)="toSoftwareTokenStep.next()">
        {{ 'LOGIN.AUTH.RECOVERY_CODE.SOFTWARE_TOKEN_BUTTON' | translate }}
      </b>
    </p>
  </div>

  <button
    class="authentication__right__card_next mt-22"
    mat-raised-button
    (click)="insertRecoveryCode.next()"
    [disabled]="recoveryCodeInput.invalid || isLoading"
  >
    {{ 'LOGIN.AUTH.NEXT' | translate }}
  </button>
</div>
